import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b4329106"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" }
const _hoisted_2 = { class: "relative p-4 rounded-lg shadow-md bg-gray-800" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-3xl text-gray-200 mb-4" }, "Signin", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "cursor-pointer text-black font-bold hover:bg-green-600 ease-in duration-200 rounded-md bg-green-400 py-1"
}, " Submit ", -1))

import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { reactive, type UnwrapRef, ref } from 'vue';
import { UserOutlined, LockOutlined } from '@ant-design/icons-vue';
import type { FormProps } from 'ant-design-vue';
import { signinFirebase } from '@/composables/firebase';
import { signin } from '@/repository/authen';
import { setToken } from '@/util/localStorage';
import SpinnerLoading from '@/components/shared/SpinnerLoading.vue';

interface FormState {
	email: string;
	password: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SigninView',
  setup(__props) {

const { query } = useRoute();
const router = useRouter();
const store = useStore();

let isLoading = ref(false);

const formState: UnwrapRef<FormState> = reactive({
	email: '',
	password: ''
});
const handleFinish: FormProps['onFinish'] = () => login();
const handleFinishFailed: FormProps['onFinishFailed'] = (errors) => console.log(errors);

async function login() {
	if (!formState.email?.length || !formState.password?.length) {
		return;
	}
	isLoading.value = true;
	try {
		const idToken = await signinFirebase(formState.email, formState.password);
		if (idToken) {
			const jwt = await signin(idToken);
			if (jwt) {
				setToken(jwt);
				router.push(query['redirect']?.toString() ?? `/`);
				store.dispatch('alert', { type: 'success', message: 'login successfully!' });
			} else {
				store.dispatch('alert', {
					type: 'error',
					message: 'email or password is wrong, please try again!'
				});
			}
		} else {
			store.dispatch('alert', {
				type: 'error',
				message: 'email or password is wrong, please try again!'
			});
		}
	} catch (error) {
		store.dispatch('alert', { type: 'error', message: 'something went wrong, please try again!' });
	}
	isLoading.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SpinnerLoading, { loading: _unref(isLoading) }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_a_form, {
            model: formState,
            onFinish: handleFinish,
            onFinishFailed: handleFinishFailed,
            class: "flex flex-col gap-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, { class: "!mb-0" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: formState.email,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formState.email) = $event)),
                    placeholder: "Username"
                  }, {
                    prefix: _withCtx(() => [
                      _createVNode(_unref(UserOutlined), { style: {"color":"rgba(0, 0, 0, 0.25)"} })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { class: "!mb-0" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_password, {
                    value: formState.password,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formState.password) = $event)),
                    type: "password",
                    placeholder: "Password",
                    rules: [{ required: true, message: 'Please input your password!' }]
                  }, {
                    prefix: _withCtx(() => [
                      _createVNode(_unref(LockOutlined), { style: {"color":"rgba(0, 0, 0, 0.25)"} })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _hoisted_4
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["loading"])
  ]))
}
}

})